import React from 'react';
import classes from "./FooterComponent.module.css";

function FooterComponent() {
  return (
    <h1 className={classes.flexCenter}>@ Pronil Chakraborty 2022</h1>
  )
}

export default FooterComponent